import {Component}       from '@angular/core';
import {Router} from '@angular/router';
import {DataTableDirectives} from 'angular2-datatable/datatable';
import {FORM_DIRECTIVES, FORM_PROVIDERS, REACTIVE_FORM_DIRECTIVES, FormControl, FormGroup} from '@angular/forms';
import {AlertComponent} from 'ng2-bootstrap/ng2-bootstrap';
import {MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from 'ng2-bootstrap/ng2-bootstrap';
import {PaginatePipe, PaginationControlsCmp, PaginationService} from 'ng2-pagination';

import {RolesService}     from '../../service/roles.service';
import {Rol} from '../../domain/rol';
import {Page} from '../../domain/page';

@Component({
    selector: 'config-roles',
    template: require('./config.roles.component.html'),
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ConfigRolesComponent {

    private data:Rol[];

    private filter:string;

    public error:any;

    private currentPage:Page;

    public form:FormGroup;

    public itemsPerPage:number;
    public loading:boolean;
    public page:number;
    public total:number;

    public rolSelected:Rol;

    constructor(private router:Router,
                private rolesService:RolesService) {
        this.init();

        this.form.valueChanges
            .debounceTime(400)
            .subscribe(this.find.bind(this));

        this.find();
    }

    private init():void {
        this.data = [];

        this.filter = "";

        this.form = new FormGroup({
            search: new FormControl(),
            itemsPerPage: new FormControl()
        });

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;
    }

    public find():void {
        this.getData(1);
    }

    private getData(page:number):void {
        this.error = null;
        this.loading = true;
        this.rolesService.findRoles(this.filter, page, this.itemsPerPage).subscribe(
            (data) => {
                this.refreshData(data);
                this.page = page;
            },
            () => {
                this.bindError('Ocurrió un error al buscar los roles.');
            });
    }

    private refreshData(page:Page):void {
        this.data = page.content.map(rol => new Rol(rol));
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public remove(deleteModal:any):void {
        this.error = null;
        this.rolesService.delete(this.rolSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeFromView(this.rolSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar el rol.');
            });
    }

    private removeFromView(rol:Rol):void {
        let index = this.data.indexOf(rol);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.rolSelected = null;
    }

    public edit(rol:Rol):void {
        this.router.navigate(['app/home/config/editRol', rol.id]);
    }

    public create():void {
        this.router.navigate(['app/home/config/createRol']);
    }

    public getPage(page:number):void {
        this.getData(page);
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/roles/config.roles.component.ts
 **/